import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

enum Theme {
    blue,
    white,
}

@Component({
    selector: 'i360-message',
    template: `
        <mat-icon [svgIcon]="icon"></mat-icon>
        <div class="i360-text-content">
            <ng-content></ng-content>
        </div>
    `,
    styleUrls: ['./message.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MessageComponent {
    @Input() icon: string;
    @Input() theme: Theme;
    Theme = Theme;

    @HostBinding('class')
    get hostClass() {
        return `i360-${this.Theme[this.theme]}`;
    }
}
